export default __webpack_public_path__ + "static/media/image.33cd4fbe.svg";